import { Trans, useTranslation } from 'react-i18next';

import {
  AvisoColocados,
  MismoComercio,
} from '#components/mobile/comercios/MismoComercio';
import type { GrupoHistoria } from '#components/mobile/historia/escribirHistoria';
import { Boton } from '#components/mobile/ui/Boton';
import { useCategoriesById } from '#hooks/useCategories';

import { HojaTravesia, TituloHoja } from './comun';

type HojaOrdenarProps = {
  grupos: GrupoHistoria[];
  /** Tras el sí: cuántos movimientos se han ordenado. */
  colocados: number | null;
  ocupado?: boolean;
  bajando?: boolean;
  onColocar: (grupos: GrupoHistoria[]) => void;
  onDeshacer: () => void;
  onSeguir: () => void;
};

/**
 * Paso 5, tras el extracto: «Gavi ordena por comercio». Los comercios que
 * Gavi reconoce (Mercadona, la nómina…) van a su categoría de un toque;
 * lo demás se queda sin ordenar y cuenta igual.
 */
export function HojaOrdenar({
  grupos,
  colocados,
  ocupado,
  bajando,
  onColocar,
  onDeshacer,
  onSeguir,
}: HojaOrdenarProps) {
  const { t } = useTranslation();
  const { data: categorias } = useCategoriesById();
  const comercios = grupos.map(g => ({
    payee: g.payee,
    nombre: g.nombre,
    nombreCategoria: categorias?.list[g.categoria]?.name ?? '',
    n: g.ids.length,
  }));

  return (
    <HojaTravesia
      aria-label={t('Sort your history')}
      data-testid="hoja-ordenar"
      bajando={bajando}
      cabeza={
        <TituloHoja>
          <Trans>Sort your history</Trans>
        </TituloHoja>
      }
      pie={
        colocados != null && (
          <Boton
            bloque
            isDisabled={ocupado}
            data-testid="ordenar-seguir"
            onPress={onSeguir}
          >
            <Trans>Continue</Trans>
          </Boton>
        )
      }
    >
      {colocados == null ? (
        <MismoComercio
          comercios={comercios}
          colocando={ocupado}
          onColocar={payees =>
            onColocar(grupos.filter(g => payees.includes(g.payee)))
          }
          onNo={onSeguir}
        />
      ) : (
        <AvisoColocados n={colocados} onDeshacer={onDeshacer} />
      )}
    </HojaTravesia>
  );
}
